import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import DataTable from "react-data-table-component";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import { PopupModal } from "../Components";
import "./master_categories.css";
import PreviewModal from "../Components/PopupModal/PreviewModal";
import { SubHeader } from "../Components";
import { useDebounce } from "../Utils/useDebounce";
import Masters from "../Components/masters.json"
import { FormParser } from "../Components";
import { Modal } from 'react-bootstrap';
import { submitVerifiedProfile } from "../Utils/profileApi"
import { VerifiedInfo } from "./VerifiedInfo";
const VerifiedList = () => {
  const { id } = useParams();
  const [Data, SetData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(20);
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState({ image: "", id: 0 });
  const [RowId, SetRowId] = useState();
  const [search, setSearch] = useState("");
  const [proile, setProfile] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [userPage, setUserPage] = useState(1);
  const [userNext, setUserNext] = useState(null);
  const [userLoading, setUserLoading] = useState(false);
  const [userSearch, setUserSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const debouncedUserSearch = useDebounce(userSearch, 400);
  const [popupType, setpopupType] = useState("");
  const [requirementShow, setRequirementShow] = useState(false)
  const [Message, setMessage] = useState("")
  const navigate = useNavigate();
  const debouncedSearch = useDebounce(search, 500);

  const GetData = async (query = "", status = "", from = "", to = "") => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/accounts/verified-profile/?page=${currentPage}&page_size=${RowPerPage}${query ? `&search=${query}` : ""
        }${status ? `&status=${status}` : ""}${proile ? `&profile=${proile}` : ""
        }${from ? `&from_date=${from}` : ""}${to ? `&to_date=${to}` : ""}`
      );
      SetData(response.data.results);
      setTotalRows(response.data.count);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async (page = 1, searchTerm = "") => {
    if (userLoading) return;
    setUserLoading(true);
    try {
      const res = await axiosConfig.get(
        `/accounts/user-profiles/?page=${page}&page_size=20&get_all_users=1${searchTerm ? `&search_query=${searchTerm}` : ""
        }`
      );
      const results = res.data?.results || [];
      const formatted = results.map((u) => ({
        value: u.id,
        label: `${u.full_name || u.user?.first_name || "Unknown"} (${u.hcc_id})`,
      }));
      setUserOptions((prev) => (page === 1 ? formatted : [...prev, ...formatted]));
      setUserNext(res.data?.next);
    } catch (e) {
      console.error(e);
    } finally {
      setUserLoading(false);
    }
  };

  useEffect(() => {
    GetData(debouncedSearch, statusFilter, fromDate, toDate);
  }, [currentPage, RowPerPage, debouncedSearch, statusFilter, proile]);

  useEffect(() => {
    setUserPage(1);
    fetchUsers(1, debouncedUserSearch);
  }, [debouncedUserSearch]);

  const handleSearchChange = (value) => setSearch(value);
  const handleStatusChange = (selected) =>
    setStatusFilter(selected ? selected.value : "");
  const handleUserScroll = () => {
    if (userNext) {
      const nextPage = userPage + 1;
      setUserPage(nextPage);
      fetchUsers(nextPage, debouncedUserSearch);
    }
  };
  const handleUserSearch = (value) => setUserSearch(value);

  const handleFromDateChange = (value) => setFromDate(value);
  const handleToDateChange = (value) => setToDate(value);

  const handleFilter = () => {
    GetData(debouncedSearch, statusFilter, fromDate, toDate);
  };

  const tableCustomStyles = {
    cells: {
      style: { justifyContent: "center" },
    },
    headCells: {
      style: {
        justifyContent: "center",
        color: "rgb(33,37,41)",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "28px",
      },
    },
  };

  const handleRowClick = (row) =>
    navigate(`/dashboard/masters/verified/${row}/edit`);
  const [showImage, setShowImage] = useState(false);
  const Close = () => {
    setShowImage(false);
    setSelectedImage({ image: "", id: 0 });
  };
  const Show = (image, id) => {
    setSelectedImage({ image: image, id: id });
    setShowImage(true);
  };
  const handleDelete = async (id) => {
    try {
      await axiosConfig.delete(`/accounts/verified-profile/${id}/`);
      SetAlertDeletePopupType("error");
      setDeletepopupType("success");
      GetData(debouncedSearch, statusFilter, fromDate, toDate);
    } catch (error) {
      setDeletepopupType("error");
      SetAlertDeletePopupType("error");
      console.log(error);
    }
  };
  const FormSubmit = async (Data) => {
    try {
      await submitVerifiedProfile(Data);
      GetData();
      setRequirementShow(false)
      setMessage("Verified Created Successfully!");
      setpopupType("success");
    } catch (error) {
      console.log(error?.response || error);
      setMessage(error?.response?.data?.message || "Something went wrong");
      setpopupType("error");
    }
  };
  const columns = [
    {
      name: "S.No",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
    },
    {
      name: "ICC ID",
      selector: (row) => row.profile?.hcc_id || "--",
    },
    {
      name: "Name",
      selector: (row) => row.name || "--",
    },
    {
      name: "Mobile Number",
      selector: (row) => row.mobile_number,
    },
    {
      name: "Gender",
      selector: (row) => row.gender,
    },
    {
      name: "Careated At",
      selector: (row) => {
        if (!row?.created_at) return "--";
        const d = new Date(row?.created_at);
        return `${d.toLocaleString("default", { month: "long" })} ${d.getDate()}, ${d.getFullYear()}`;
      },
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "ACTIONS",
      cell: (row) => (
        <>
          <div className="row">
            <div className="col-4">
              <MdOutlineRemoveRedEye
                className="dashboard-tabe-data-actions"
                onClick={() => handleRowClick(row.id)}
              />
            </div>
          </div>
          {AlertDeletePopupType === "success" && (
            <AlertDeletePopupModal
              AlertDeletePopupType={AlertDeletePopupType}
              HandleDelete={handleDelete}
              CancelAlerrt={() => SetAlertDeletePopupType("error")}
              row={RowId}
            />
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: id ? "none" : "block" }}>
        <div className="child-sidenav">
          <div className="childnav-content">
            <div className="marginTop">
              <DataTable
                columns={columns}
                data={Data}
                pagination
                paginationTotalRows={totalRows}
                paginationPerPage={RowPerPage}
                paginationDefaultPage={currentPage}
                onChangePage={(page) => setCurrentPage(page)}
                onChangeRowsPerPage={(newRows) => setRowPerPage(newRows)}
                paginationServer
                fixedHeader
                subHeader
                subHeaderComponent={
                  <SubHeader
                    selectOptions={[
                      {
                        options: [
                          { value: "", label: "All Status" },
                          { value: "requested", label: "Requested" },
                          { value: "approved", label: "Approved" },
                          { value: "rejected", label: "Rejected" },
                        ],
                        onChange: handleStatusChange,
                        placeholder: "Filter by Status",
                      },
                    ]}
                    extraSelectOptions={[
                      {
                        options: userOptions,
                        onChange: (selected) => setProfile(selected?.value),
                        onScroll: handleUserScroll,
                        onSearch: handleUserSearch,
                        isLoading: userLoading,
                        placeholder: "Filter by User",
                      },
                    ]}
                    searchValue={search}
                    onSearchChange={handleSearchChange}
                    fromDate={fromDate}
                    toDate={toDate}
                    onFromDateChange={handleFromDateChange}
                    onToDateChange={handleToDateChange}
                    onFilter={handleFilter}
                    buttons={[
                      {
                        title: "Add Verifier",
                        onClick: () => setRequirementShow(true),
                        className: "btn-success",
                      },
                    ]}
                  />
                }
                customStyles={tableCustomStyles}
                progressPending={loading}
                progressComponent={
                  <div className="loader-container">
                    <img
                      src={require("../Components/FormParser/images/loader2.gif")}
                      alt="Loading..."
                    />
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: id ? "block" : "none" }}>
        <VerifiedInfo />
      </div>
      {showImage && (
        <PreviewModal
          show={showImage}
          handleClose={Close}
          selectedImage={selectedImage}
        />
      )}
      {popupType != "" &&
        <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="" Message={Message} />
      }
      <Modal
        size="lg"
        show={requirementShow}
        onHide={() => {
          setRequirementShow(false)
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Add Verifier
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormParser modelObject={Masters.VerificationAdd} formSubmit={FormSubmit} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export { VerifiedList };
